import { render, staticRenderFns } from "./Biz.vue?vue&type=template&id=0fe979cf&scoped=true&"
import script from "./Biz.vue?vue&type=script&lang=js&"
export * from "./Biz.vue?vue&type=script&lang=js&"
import style0 from "./Biz.vue?vue&type=style&index=0&id=0fe979cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe979cf",
  null
  
)

export default component.exports